export const UPDATE_RECORD_HEADING = `Update Record`;
export const DELETE_RECORD_HEADING = `Delete Record`;
export const DELETE_RECORD_MESSAGE = `Are you sure you want to delete`;
export const CANCEL_RECORD_MESSAGE_1 = `Do you wish to cancel this record?`;
export const CANCEL_RECORD_MESSAGE_2 = `Are you SURE you want to cancel this record?`;
export const MISSING_REQUIRED_FIELDS_MESSAGE = `Please complete all required fields before saving.`;


export const DELETE_ISSUE_SECOND_CONFIRMATION_HEADING =
  '2nd Cancellation Confirmation';


